import { memo } from "react";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import AddPaymentMethod from "./AddPaymentMethod";
import SearchPaymentMethod from "./SearchPaymentMethod";
import { usePaymentMethodsContext } from "../PaymentMethodsProvider";

const PaymentMethodsToolbar = () => {
    const {
        providerOptions,
        providers,
        setProviders,
        setTags,
        tagOptions,
        tags
    } = usePaymentMethodsContext();

    return (
    <Box
        sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 2
        }}
    >
        <SearchPaymentMethod />
        <Autocomplete
            multiple
            freeSolo
            size='small'
            sx={{ width: 180 }}
            options={providerOptions}
            value={providers}
            onChange={(_, values) => setProviders(values)}
            renderInput={params => (
                <TextField
                    {...params}
                    label='Provider'
                    placeholder='Type or select a provider'
                    inputProps={{
                        ...params.inputProps,
                        'data-test-id': 'paymentMethods.providerFilter'
                    }}
                />
            )}
        />
        <Autocomplete
            multiple
            freeSolo
            size='small'
            sx={{ width: 180 }}
            options={tagOptions}
            value={tags}
            onChange={(_, values) => setTags(values)}
            renderInput={params => (
                <TextField
                    {...params}
                    label='Tag'
                    placeholder='Type or select a tag'
                    inputProps={{
                        ...params.inputProps,
                        'data-test-id': 'paymentMethods.tagFilter'
                    }}
                />
            )}
        />
        <AddPaymentMethod />
    </Box>
    );
};

export default memo(PaymentMethodsToolbar);
